export const ERROR_WENT_WRONG =
  "Oops! Something went wrong. Please try again later.";
